import { Fragment, useMemo, useState } from "react";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import "sweetalert2/dist/sweetalert2.min.css";
import { toast } from "react-toastify";
import { getCategoryColumns } from "../../Components/product/Category.columns";
import { CategoryModal } from "../../Components/order/CategoryModal";
import { useAdmin } from "../../../context/AdminContext";
import { PageHeader } from "../../Components/common/PageHeader";

export const CategoryList = () => {
  const { getData, patchData, postData, invalidateQuery } = useDataFetch();
  const { admin } = useAdmin();
  const { data, isLoading } = getData(["categories"], "/product/all/categories", { enabled: true });

  const { mutateAsync: toggleCategory } = patchData("/product/category/toggle-status", {}, {
    onSuccess: (response) => {
      if (response.message === "toggle_category_status_success") {
        toast.success("Estado de la categoría actualizado");
        invalidateQuery(["categories"]);
      }
    },
  });

  const { mutateAsync: createCategory } = postData("/product/category", {}, {
    onSuccess: (response) => {
      if (response.message === "create_category_success") {
        toast.success("Categoría creada exitosamente");
        invalidateQuery(["categories"]);
        closeModal();
      }
    },
  });

  const { mutateAsync: updateCategory } = patchData("/product/category", {}, {
    onSuccess: (response) => {
      if (response.message === "category_updated_successfully") {
        toast.success("Categoría actualizada exitosamente");
        invalidateQuery(["categories"]);
        closeModal();
      }
    },
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
  });

  const openModalForCreate = () => {
    setFormData({ id: "", name: "" });
    setModalOpen(true);
  };

  const openModalForEdit = (category) => {
    setFormData({ id: category.id, name: category.name });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setFormData({ id: "", name: "" });
  };

  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () => getCategoryColumns(columnHelper, openModalForEdit, toggleCategory,admin?.role),
    [columnHelper]
  );

  const categoryData = data?.data?.categories ?? [];

  // `/product/all/categories` no pagina en el backend: pagina en cliente
  // sobre lo ya cargado, sin duplicar el fetch (ver README, "Estado y datos").
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const pageData = categoryData.slice(
    pagination.pageIndex * pagination.pageSize,
    (pagination.pageIndex + 1) * pagination.pageSize
  );

  return (
    <Fragment>
      <PageHeader
        title="Categorías"
        crumbs={[{ label: "Productos" }, { label: "Categorías" }]}
        actions={
          <button
            type="button"
            className="btn btn-primary btn-sm d-flex align-items-center gap-1"
            disabled={admin?.role === "ASSISTANT"}
            onClick={openModalForCreate}
          >
            <i className="ri-add-line" /> Registrar categoría
          </button>
        }
      />

      <DataTable
        data={pageData}
        total={categoryData.length}
        pagination={pagination}
        setPagination={setPagination}
        columns={columns}
        progressPending={isLoading}
        emptyMessage="No hay categorías para mostrar."
      />

      <CategoryModal
        modalOpen={modalOpen}
        closeModal={closeModal}
        formData={formData}
        setFormData={setFormData}
        createCategory={createCategory}
        updateCategory={updateCategory}
      />
    </Fragment>
  );
};
